<template>
  <protected-pages-layout>
    <div class="wrapper">
      <div v-if="!pageReady" class="d-flex justify-content-center align-items-center m-5">
        <div class="spinner-border text-dark" style="width: 7.5rem; height: 7.5rem" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else class="main-content">
        <div class="container-fluid">
          <div class="row" style="margin: 30px 0">
            <div class="col-md-10 offset-md-1">
              <form>
                <div class="row">
                  <div class="col">
                    <label for="teamSelect">Team</label>
                    <select v-model="parameters.team" class="form-select" id="teamSelect" @change="getReport()">
                      <option :key="index" :value="team.ID" v-for="(team, index) in teams">
                        {{ team.Name }}
                      </option>
                    </select>
                  </div>
                  <div class="col">
                    <label for="billableSelect">Report Type</label>
                    <select v-model="parameters.teamMembersReportType" class="form-select" id="billableSelect"
                      @change="getReport()">
                      <option :key="index" :value="option.value" v-for="(option, index) in teamMembersReportTypes">
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col">
                    <label for="periodSelect">Period</label>
                    <select v-model="parameters.period" class="form-select" id="periodSelect" @change="getReport()">
                      <option :key="index" :value="period.value" v-for="(period, index) in periods">
                        {{ period.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="col-md-3">
            <div class="card border-0 shadow card-dashboard">
              <div class="card-body" @click="openTotalsModal">
                <h6 class="card-subtitle mb-2 text-muted">Total (days)</h6>
                <h3 class="card-title" v-if="total">{{ 
                totalAsDay
                }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="dashboard-team-wrapper">
          <div class="dashboard-team-data">
            <div class="dashboard-team-cards-row" v-for="people in chart" :key="people.name">
              <div class="card card-dashboard border-0 shadow card-size">
                <div class="card-body card-size" @click="switchMode()">
                  <h6 class="card-subtitle mb-2 text-muted">{{ people.name }}</h6>
                  <h6 class="card-text" style="font-size: 15px" v-if="smallCardView">
                    <span class="card-subtitle mb-2 text-muted">total: </span>
                    <b v-if="parameters.teamMembersReportType === 'project'">
                      {{ people.sumAllProjects }} hours
                    </b>
                    <b v-else> {{ people.sumAll }} hours </b>
                  </h6>
                  <h6 class="card-text" style="font-size: 15px" v-else>
                    <span class="card-subtitle mb-2 text-muted">total: </span>
                    <b v-if="parameters.teamMembersReportType === 'project'">
                      {{ people.sumAllProjects }} hours
                    </b>
                    <b v-else> {{ people.sumAll }} hours </b>

                    <br />
                    <span class="card-subtitle mb-2 text-muted"
                      v-if="parameters.teamMembersReportType === 'project'">CS: <b>{{ people.sumCS }} hours</b></span>
                    <span class="card-subtitle mb-2 text-muted" v-else><font-awesome-icon icon="dollar-sign"
                        color="green" />:
                      <b>{{ people.sumBillable }} hours</b></span>
                    <br />
                    <span class="card-subtitle mb-2 text-muted"
                      v-if="parameters.teamMembersReportType === 'project'">PS: <b>{{ people.sumPS }} hours</b></span>
                    <span class="card-subtitle mb-2 text-muted" v-else><font-awesome-icon icon="dollar-sign"
                        color="red" />:
                      <b>{{ people.sumNonBillable }} hours</b></span>
                    <br />
                    <span class="card-subtitle mb-2 text-muted"
                      v-if="parameters.teamMembersReportType === 'project'">Onboarding: <b>{{ people.sumOnBoarding }}
                        hours</b></span>
                    <span class="card-subtitle mb-2 text-muted" v-else><font-awesome-icon icon="user" color="#6C757D"
                        class="user-icon" />: <b>{{ people.sumInternal }} hours</b></span>
                    <br v-if="parameters.teamMembersReportType === 'project'" />
                    <span class="card-subtitle mb-2 text-muted"
                      v-if="parameters.teamMembersReportType === 'project'">Other: <b>{{ people.sumOtherProjects }}
                        hours</b></span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="card" id="card-chart" v-if="!empty">
            <barChart :data="chartData" :key="barChartKey"></barChart>
          </div>
          <div class="card" id="card-chart" v-else>
            <h3 class="card-title">No Data to display</h3>
          </div>
        </div>
        <div class="d-flex justify-content-center mb-5 pb-5 h-fit">
          <button class="btn btn-outline-primary me-3" @click="csvExport(chart)">
            Download chart data
          </button>
          <button class="btn btn-primary" @click="fetchReportDetails">
            Download details
          </button>
        </div>
      </div>
    </div>

    <!-- Custom Totals Modal -->
    <div v-if="showTotalsModal" class="modal-overlay">
      <div class="modal-window">
        <div class="modal-header d-flex justify-content-between align-items-center p-3 border-bottom">
          <h6 class="mb-0">Totals</h6>
          <button type="button" class="btn-close" @click="showTotalsModal = false"></button>
        </div>
        <div class="modal-body p-3">
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="(value, key) in totals" :key="key" style="list-style: none">
              {{ key }}: {{ value }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </protected-pages-layout>
</template>

<script setup>
import { periods, teamMembersReportTypes } from "../assets/variables.js";
import { storeToRefs } from "pinia";
import { ref, onMounted, computed } from "vue";
import { useTeamMembersReportStore } from "../stores/teamMembersReport.js";

const teamMembersReportStore = useTeamMembersReportStore();

const {
  getTeams: teams,
  getTotal: total,
  getChart: chart,
  getParameters: parameters,
  getChartData: chartData,
  getBarChartKey: barChartKey,
  getEmpty: empty,
  getTotals: totals,
} = storeToRefs(teamMembersReportStore);

const {
  fetchTeams,
  getReport,
  calculateTotals,
  fetchReportDetails,
  csvExport,
} = teamMembersReportStore;

let pageReady = ref(false);
let smallCardView = ref(true);

const switchMode = () => {
  smallCardView.value = !smallCardView.value;
};

onMounted(async () => {
  await fetchTeams();
  await getReport();
  console.log(chart.value);
  pageReady.value = true;
});

const totalAsDay = computed(() => {
  if (!total.value) return 0;
  let result = numberWithCommas(parseFloat(total.value).toFixed(2))
  return result;
});

const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// Custom totals modal state
const showTotalsModal = ref(false);
const openTotalsModal = () => {
  calculateTotals();
  showTotalsModal.value = true;
};


</script>

<script>
import Navbar from "../components/Navbar.vue";
import ExportModule from "../components/ExportModule.vue";
import barChart from "../components/charts/TeamReportChart.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "PeopleReport",
  components: {
    navbar: Navbar,
    barChart,
    ExportModule,
  },
});
</script>

<style lang="scss">
.wrapper {
  width: clamp(
    867px,
    calc(100vw * 0.8465),
    2166px
  );
  aspect-ratio: 1219/811;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  padding-bottom: 50px;  // Add extra space at the bottom
  max-height: 100vh;
}

.card {
  margin-top: 10px;
}

.group-header {
  color: #6c757d !important;
  font-weight: bolder;
  text-decoration: none;
  margin: 0px 13px;
  list-style-type: none;
}

h2 {
  text-align: center;
}

.entry-detail {
  text-align: left;
}


.table td {
  cursor: pointer;
}

ul {
  padding-inline-start: 0px;
}

.dashboard-team-wrapper {
  @media (min-width: 50px) {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  @media (min-width: 768px) {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  @media (min-width: 1024px) {
    width: 100%;
    height: max-content;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0 !important;
    position: relative;
  }
}

.dashboard-team-data {
  @media (min-width: 1024px) {
    width: 100%;
    height: max-content;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
  }
}

.dashboard-team-cards-row {
  @media (min-width: 50px) {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  @media (min-width: 768px) {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }

  @media (min-width: 1024px) {
    width: 25%;
    gap: 0 !important;
    justify-content: space-evenly;
    margin: 0 !important;
    gap: 0 3.5% !important;
  }
}

.card-size {
  @media (min-width: 50px) {
    width: 45%;
    height: 20%;
  }

  @media (min-width: 768px) {
    width: 45%;
    height: max-content;
  }

  @media (min-width: 1024px) {
    width: 100%;
    height: max-content;
  }
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.modal-window {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 500px;
}
</style>
